export default __webpack_public_path__ + "static/media/i1.b712aa38.jpg";